var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isExpandable || _vm.opened || _vm.isMobile() || _vm.isTablet()
    ? _c(
        "tr",
        {
          staticClass: "z-table-row z-table-row--body",
          class: _vm.buildClass,
          on: {
            click: function ($event) {
              return _vm.check()
            },
          },
        },
        [_vm._t("default")],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }